import React from 'react';
import styled from 'styled-components';

const Skills = ({ lang }) => {
  return (
    <Container>
      <div className='max-w-box mild-gradient-bg'>
        <div className='box-tag'>CPU</div>
        <div className='box-heading box-heading-cpu-color'>Hard skills</div>
        <p className='box-sub-heading'>
          작업은 주로 Nodejs.
          <br />
          그리고 Python.
        </p>
        <div className='box-detail'>
          <div className='box-desc-heading'>Expert in</div>
          <p className='box-description'>
            AWS, Docker, PostgreSQL, MySQL, DynamoDB, Redis, MongoDB, Firebase,
            React, Nextjs
          </p>
        </div>
        <div className='box-detail'>
          <div className='box-desc-heading'>Experienced</div>
          <p className='box-description'>
            Elasticsearch, Hasura, Socket.io, Django
          </p>
        </div>
      </div>
      <div className='max-w-box predawn-gradient-bg'>
        <div className='box-tag'>GPU</div>
        <div className='box-heading box-heading-gpu-color'>Soft skills</div>
        <p className='box-sub-heading'>
          원활한 소통 전문가.
          <br />
          일은 열정적으로.
        </p>
        <div className='box-detail'>
          <div className='box-desc-heading'>Experienced</div>
          <p className='box-description'>
            Sales, Researcher, Exhibition coordinator
          </p>
        </div>
      </div>
    </Container>
  );
};

const Container = styled.section`
  display: grid;
  grid-template-rows: repeat(2, minmax(0, 1fr));
  row-gap: 24px;
  margin: 0 0 200px;

  .max-w-box {
    border-radius: 25px;
    text-align: left;
    padding: 40px;

    .box-tag {
      margin-bottom: 80px;
      color: #fff;
      font-size: 19px;
      font-weight: 600;
    }

    .box-heading {
      font-size: 48px;
      font-weight: 700;
      margin: 0;
    }

    .box-sub-heading {
      font-size: 48px;
      font-weight: 700;
      margin: 0;
      color: #fff;
      margin-bottom: 24px;
    }

    .box-detail {
      font-size: 19px;
      margin-bottom: 24px;

      .box-desc-heading {
        color: #fff;
        margin-bottom: 8px;
      }

      .box-description {
        margin: 0;
      }
    }
  }

  .mild-gradient-bg {
    background: linear-gradient(45deg, #141e30 50%, #243b55);
  }

  .predawn-gradient-bg {
    background: linear-gradient(45deg, #194189 0%, #3b4980 25%, #8738a7 100%);
  }

  .box-heading-gpu-color {
    color: #c48cfc;
  }

  .box-heading-cpu-color {
    color: #8ca2fc;
  }

  @media only screen and (min-width: 769px) {
    .max-w-box {
      .box-heading {
        font-size: 64px;
      }

      .box-sub-heading {
        font-size: 64px;
      }
    }
  }

  @media only screen and (min-width: 1025px) {
  }
`;

export default Skills;
